import Cookies from 'js-cookie'

const hostname: string = window.location.hostname

export const setCookie = (name: string, value: string, opts?: any) => {
  opts = opts || {
    domain: hostname
  }
  Cookies.set(name, value, opts)
}

export const getCookie = (name: string) => {
  return Cookies.get(name)
}

export const removeCookie = (name: string, opts?: any) => {
  opts = opts || {
    domain: hostname
  }
  Cookies.remove(name, opts)
}

export const clearCookie = () => {
  let cookies = Cookies.get()
  Object.keys(cookies).forEach((name: string) => {
    Cookies.remove(name, {
      domain: hostname
    })
  })
}